<div class="container mobile">
  <h2>{{'Environnement' | translate}}</h2>
  <p>
    {{description1.text}}
  </p>
  <div class="footer">
    <div class="wire-btn" [routerLink]="['/availabilities']">
      <span>{{'Voir les disponibilités' | translate}}</span>
    </div>
  </div>
  <img src="../../../assets/Description/pic1.jpg" alt="villa">
  <h2>{{'La villa' | translate}}</h2>
  <p>
    {{description2.text}}
  </p>
  <div class="footer">
    <div class="wire-btn" [routerLink]="['/equipment']">
      <span>{{'Voir les équipements' | translate}}</span>
    </div>
  </div>
  <img src="../../../assets/Description/pic2.jpg" alt="villa">
  <h2>{{'En Détails' | translate}}</h2>
  <p>
    {{description3.text}}
  </p>
  <img src="../../../assets/Description/pic3.jpg" alt="plan">
</div>